import { GatewayError } from '../gateway/GatewayClient';

export const MAXIMUM_RECONNECT_ATTEMPTS = 6;
export const SERVER_CAPACITY_RETRY_MILLISECONDS = 5_000;

const RECONNECT_DELAYS_MILLISECONDS = [0, 250, 500, 1_000, 2_000, 4_000] as const;

export function reconnectDelayMilliseconds(attempt: number): number {
  if (!Number.isSafeInteger(attempt) || attempt < 1) {
    throw new RangeError('Reconnect attempts start at one.');
  }
  return (
    RECONNECT_DELAYS_MILLISECONDS[Math.min(attempt, RECONNECT_DELAYS_MILLISECONDS.length) - 1] ??
    4_000
  );
}

export function isReconnectableSessionError(error: unknown): error is GatewayError {
  return (
    error instanceof GatewayError &&
    [
      'gateway_unreachable',
      'gateway_interrupted',
      'legacy_disconnected',
      'legacy_timeout',
      'legacy_unavailable',
      'resume_failed',
    ].includes(error.code)
  );
}

export function isServerCapacityWait(error: unknown): error is GatewayError {
  return error instanceof GatewayError && error.code === 'server_full';
}

export function isTerminalSessionError(error: unknown): error is GatewayError {
  return (
    error instanceof GatewayError &&
    ['invalid_session', 'missing_session', 'resume_expired', 'session_replaced'].includes(
      error.code,
    )
  );
}
